import React from "react";
import {UserWithStats} from "../UserWithStats";
import {TFunction} from "i18next";


export class LeaderboardStrategy {
    getGamemodeInformations(t: TFunction<"translation", undefined>, userStats: UserWithStats): React.ReactNode {
        return <>
            <p className="max-lg:hidden w-fit">{t("leaderboard.accuracy-x", {accuracy: userStats.accuracy})}</p>
            <p className="max-lg:hidden w-fit">{t("leaderboard.mean-x", {mean: userStats.mean})}</p>
            <p className="w-fit max-lg:text-text-transparent">{t("leaderboard.best-score-x", {score: userStats.best})}</p>
        </>;
    }

    getGamemodeSubtitle(t: TFunction<"translation", undefined>): string {
        return ""
    }
}
